"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToEcommerce = void 0;
const helpers_1 = require("../helpers");
const getItemId = (itemId, category, name) => {
    if (category === 'kursus') {
        const trimmedCategory = name.split('-')[0];
        return (0, helpers_1.textToCamelCase)('kursus' + trimmedCategory);
    }
    return itemId;
};
/**
 * Manual solution to make sure no translation errors between this function and CRM occurs
 *
 * @param activityTypeEnumValue Enum value of activity type from CR
 * @returns the corresponding activity type
 */
const getActivityType = (activityTypeEnumValue) => {
    switch (activityTypeEnumValue) {
        case 2: // MemberActivity [CRM]
            return 'fagtekniske arrangementer';
        case 4: // PersonalDevelopmentActivity [CRM]
            return 'personligt udviklende arrangementer';
        case 5: // SocialCulturalActivity [CRM]
            return 'socialt kulturelle arrangementer';
        case 6: // ProfessionalDevelopmentActivity [CRM]
            return 'fagligt udviklende arrangementer';
        default:
            return helpers_1.empty;
    }
};
const convertToEcommerce = (item) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (!item.name || !item.id || !item.affiliation || !item.price || !item.category || !item.host) {
        //TODO: Add AI Tracking instead
        console.error('Ecommerce tracking is recieving wrong properties');
    }
    return {
        item_name: (_b = (_a = item.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : helpers_1.empty,
        item_id: item.id ? getItemId(item.id.toString().toLowerCase(), item.category.toLowerCase(), item.name) : helpers_1.empty,
        affiliation: (_d = (_c = item.affiliation) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : helpers_1.empty,
        price: (_f = (_e = item.price) === null || _e === void 0 ? void 0 : _e.toString().toLowerCase()) !== null && _f !== void 0 ? _f : helpers_1.empty,
        item_category: (_h = (_g = item.category) === null || _g === void 0 ? void 0 : _g.toLowerCase()) !== null && _h !== void 0 ? _h : helpers_1.empty,
        item_category2: getActivityType(item.activityType),
        item_category3: (_k = (_j = item.host) === null || _j === void 0 ? void 0 : _j.toLowerCase()) !== null && _k !== void 0 ? _k : helpers_1.empty,
        quantity: (_m = (_l = item.quantity) === null || _l === void 0 ? void 0 : _l.toString().toLowerCase()) !== null && _m !== void 0 ? _m : '1',
        currency: (_o = item.currencyCode) !== null && _o !== void 0 ? _o : 'DKK',
    };
};
exports.convertToEcommerce = convertToEcommerce;
class ECommerceManager {
    viewItem(item) {
        window.dataLayer.push({
            event: 'view_item',
            ecommerce: {
                items: [(0, exports.convertToEcommerce)(item)],
            },
        });
    }
    addToCart(item) {
        window.dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                items: [(0, exports.convertToEcommerce)(item)],
            },
        });
    }
    beginCheckout(item) {
        window.dataLayer.push({
            event: 'begin_checkout',
            ecommerce: {
                items: [(0, exports.convertToEcommerce)(item)],
            },
        });
    }
    addPaymentInfo(item) {
        var _a;
        window.dataLayer.push({
            event: 'add_payment_info',
            ecommerce: {
                payment_type: (_a = item.paymentType) !== null && _a !== void 0 ? _a : helpers_1.empty,
                items: [(0, exports.convertToEcommerce)(item)],
            },
        });
    }
    purchase(item) {
        var _a, _b, _c, _d, _e;
        window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
                currency: (_a = item.currencyCode) !== null && _a !== void 0 ? _a : 'DKK',
                value: (_c = (_b = item.price) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase()) !== null && _c !== void 0 ? _c : helpers_1.empty,
                transaction_id: (_e = (_d = item.id) === null || _d === void 0 ? void 0 : _d.toString().toLowerCase()) !== null && _e !== void 0 ? _e : helpers_1.empty,
                items: [(0, exports.convertToEcommerce)(item)],
            },
        });
    }
    viewItemList(items) {
        window.dataLayer.push({
            event: 'view_item_list',
            ecommerce: {
                items: items.map((item) => {
                    var _a;
                    if (!item.index || !item.listName) {
                        //TODO: Add AI Tracking instead
                        console.error('Ecommerce tracking is recieving wrong properties');
                    }
                    return Object.assign({ index: item.index ? (item.index + 1).toString() : '1', item_list_name: (_a = item.listName) !== null && _a !== void 0 ? _a : helpers_1.empty }, (0, exports.convertToEcommerce)(item));
                }),
            },
        });
    }
    selectItem(item) {
        var _a;
        if (!item.index || !item.listName) {
            //TODO: Add AI Tracking instead
            console.error('Ecommerce tracking is recieving wrong properties');
        }
        window.dataLayer.push({
            event: 'select_item',
            ecommerce: {
                items: [
                    Object.assign({ index: item.index ? (item.index + 1).toString() : '1', item_list_name: (_a = item.listName) !== null && _a !== void 0 ? _a : helpers_1.empty }, (0, exports.convertToEcommerce)(item)),
                ],
            },
        });
    }
}
exports.default = ECommerceManager;
